import { ITableField } from "shared/Table"
import { IProjectRole } from "../../projectRoles.types"


const projectRolesTableFields: ITableField<IProjectRole, keyof IProjectRole | string>[] = [
  {
    key: 'id',
    header: 'id',
    getter: (projectRole) => projectRole.id,
    sortGetter: (projectRole) => projectRole.id,
    width: '400px',
  },
  {
    key: 'title',
    header: 'Название',
    getter: (projectRole) => projectRole.title,
    sortGetter: (projectRole) => projectRole.title,
    width: '300px',
  },
  {
    key: 'description',
    header: 'Описание',
    getter: (projectRole) => projectRole.description,
    sortGetter: (projectRole) => projectRole.description,
    width: '300px',
  },
]
export default projectRolesTableFields
